<template>
    <v-col cols="12">
        <v-select
            label="What type of printing do you do?"
            v-model="form.copier.type_of_printing"
            variant="outlined"
            density="compact"
            :multiple="true"
            :items="[
                'CAD/CAM',
                'Construction/Architectural',
                'Advertising (e.g. Bannes, Posters)',
                'Artwork/High-end graphics/photos',
                'Apparel',
                'Others/Not sure',
            ]">
        </v-select>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
